
      (function () {
        "use strict";
        var REDUCED =
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        /* ---------- assets ---------- */
        var WC_SPRITE =
          "https://cdn.shopify.com/s/files/1/0883/0874/4471/files/warrior-grip-series-sprite.webp?v=1791357929";
        var TR_LOGO =
          "https://cdn.shopify.com/s/files/1/0883/0874/4471/files/tr-logo.png?v=1791357926";
        var SWING_SPRITE =
          "https://cdn.shopify.com/s/files/1/0883/0874/4471/files/tr-swing-sprite.webp?v=1791357927";
        var COURSE_SHOT =
          "https://cdn.shopify.com/s/files/1/0883/0874/4471/files/tr-course-shot.webp?v=1791357926";

        document.getElementById("clubBox").style.backgroundImage =
          "url(" + WC_SPRITE + ")";
        var WC_STATIC =
          "data:image/webp;base64,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";
        document.getElementById("dockClub").src = WC_STATIC;
        document.getElementById("dockbox").classList.add("docked");
        document.getElementById("trLogoTop").src = TR_LOGO;
        document.getElementById("trLogoFoot").src = TR_LOGO;
        document.getElementById("courseShot").src = COURSE_SHOT;
        document.getElementById("stage").style.backgroundImage =
          "url(" + SWING_SPRITE + ")";

        /* ---------- data ---------- */
        var URLS = {
          7: "https://shop.tagdaraho.in/products/warrior-club-7-kg-free-online-home-workout-series",
          10: "https://shop.tagdaraho.in/products/warrior-club-10-kg-free-online-home-workout-series",
        };
        /* LIVE PRODUCT DATA (shop.tagdaraho.in, Oct 2026): Warrior Club 7 kg Rs.7,999 / 10 kg Rs.9,999.
   On-site grip variants exist per product: "Default grip" and "Default + Dharwad grip" (+Rs.800);
   standalone Warrior Grip Rs.1,699 (MRP 2,499). Claude Code: wire grip variant IDs via the product picker. */
        var WEIGHTS = [
          { kg: 7, price: 7999, mrp: 0, series: "Warrior" },
          { kg: 10, price: 9999, mrp: 0, series: "Warrior" },
        ];
        var CDN = "https://shop.tagdaraho.in/cdn/shop/files";
        function g(f, v) {
          return CDN + "/" + f + "?v=" + v + "&width=800";
        }
        /* per-product galleries pulled from the live PDPs */
        var GALLERIES = {
          warrior7: [
            g("Artboard8.webp", "1784815430"),
            g("warriorclub7kg.webp", "1784890716"),
            g("warrio-club.webp", "1786350665"),
            g(
              "Artboard5_f0e6d37c-be87-416b-b868-f2c1dd6bfa65.webp",
              "1784815430",
            ),
            g("Artboard7.webp", "1784815430"),
            g("Artboard11.webp", "1784815430"),
            g("Artboard9.webp", "1784815431"),
            g("spf.webp", "1784540875"),
            g("WhatsApp_Image_2026-04-21_at_5.37.37_PM.webp", "1776784689"),
            g(
              "classic-hanuman-gada-free-online-home-workout-series-9371326_1.webp",
              "1776770850",
            ),
          ],
          warrior10: [
            g("Warrior.webp", "1784912483"),
            g("Artboard8.webp", "1784815430"),
            g("warrio-club.webp", "1786350665"),
            g("Artboard10.webp", "1784815430"),
            g("Artboard4.webp", "1784815430"),
            g("Artboard1.webp", "1784815430"),
            g("spf.webp", "1784540875"),
            g("WhatsApp_Image_2026-04-20_at_3.50.30_PM.webp", "1776773719"),
            g(
              "classic-hanuman-gada-free-online-home-workout-series-9371326_1.webp",
              "1776770850",
            ),
          ],
        };
        function galKey() {
          return "warrior" + WEIGHTS[selWt].kg;
        }
        var GALLERY = GALLERIES.warrior7.slice();
        var THUMBS = GALLERY.map(function (u) {
          return u.replace("width=800", "width=120");
        });
        var SPR = { cols: 6, rows: 6, n: 36 };
        var MUSCLES = [
          {
            name: "Shoulders & Deltoids",
            score: 4,
            desc: "Guide, stabilize, and control the Gada through every swing.",
          },
          {
            name: "Core & Obliques",
            score: 3,
            desc: "Maintain balance and transfer force efficiently throughout the movement.",
          },
          {
            name: "Grip & Forearms",
            score: 4,
            desc: "Stay engaged continuously to manage the shifting load.",
          },
          {
            name: "Back & Lats",
            score: 3,
            desc: "Support posture and help control momentum during the return phase.",
          },
          {
            name: "Glutes & Hips",
            score: 2.5,
            desc: "Generate power and connect the lower body to every swing.",
          },
        ];
        var PHASES = [
          [
            "THE GRIP",
            "Feet root. Breath draws in. The mace loads over the shoulder.",
          ],
          [
            "THE CAST",
            "Hips initiate. The Gada travels overhead \u2014 shoulders open through their full arc.",
          ],
          [
            "THE FIGHT",
            "Behind the back, gravity accelerates the head. Core and lats fire to decelerate. This is the work.",
          ],
          [
            "THE PULL",
            "The pull-through returns the mace to the start. Each rep is a negotiation.",
          ],
        ];
        var QUIZ = [
          {
            q: "How do you train right now?",
            o: [
              ["New \u00B7 getting back into it", 0],
              ["2\u20134 sessions a week", 1],
              ["Athlete / advanced", 2],
            ],
          },
          {
            q: "What\u2019s the goal?",
            o: [
              ["Mobility & foundation", 0],
              ["Strength & conditioning", 1],
              ["Power & performance", 2],
            ],
          },
          {
            q: "Your bodyweight?",
            o: [
              ["Under 70 kg", 0],
              ["70\u201385 kg", 1],
              ["Over 85 kg", 2],
            ],
          },
        ];
        var REC_REASON = [
          "The 7 kg Warrior is the standard \u2014 roughly 21\u201325 kg effective at peak arc, with the full grip system to grow through.",
          "You have the base. The 10 kg peaks past 30 kg effective \u2014 the Club\u2019s test of grit and control.",
        ];

        /* ---------- state ---------- */
        var selWt = 0,
          galIdx = 0;
        var quiz = { step: 0, score: 0, done: false, rec: -1 };
        var $ = function (id) {
          return document.getElementById(id);
        };
        var rupee = function (n) {
          return "\u20B9" + n.toLocaleString("en-IN");
        };

        /* ---------- build mass arrows ---------- */
        (function () {
          var wrap = $("massArrows"),
            i;
          for (i = 0; i < 7; i++) {
            var s = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "svg",
            );
            s.setAttribute("width", "14");
            s.setAttribute("height", "8");
            s.setAttribute("viewBox", "0 0 14 8");
            s.style.opacity = 0.2 + (6 - i) * 0.09;
            s.style.animation = "aPL 1.6s ease " + i * 0.12 + "s infinite";
            s.innerHTML =
              '<path d="M14 4 L4 4 M7 1 L2 4 L7 7" stroke="#4A6B45" stroke-width=".9" fill="none"/>';
            wrap.appendChild(s);
          }
          var da = $("dockarrows");
          for (i = 0; i < 3; i++) {
            var a = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "svg",
            );
            a.setAttribute("width", "26");
            a.setAttribute("height", "10");
            a.setAttribute("viewBox", "0 0 26 10");
            a.style.opacity = 0.5 + i * 0.15;
            a.style.animation = "aPL 1.4s ease " + i * 0.2 + "s infinite";
            a.innerHTML =
              '<path d="M26 5 L8 5 M11 1.5 L5 5 L11 8.5" stroke="#4A6B45" stroke-width="1.3" fill="none"/>';
            da.appendChild(a);
          }
        })();

        /* ---------- carousel ---------- */
        function buildGallery(key) {
          GALLERY = GALLERIES[key].slice();
          THUMBS = GALLERY.map(function (u) {
            return u.replace("width=800", "width=120");
          });
          galIdx = 0;
          var box = $("carBox"),
            th = $("thumbs");
          box.querySelectorAll("img").forEach(function (im) {
            im.remove();
          });
          th.innerHTML = "";
          GALLERY.forEach(function (u, i) {
            var im = document.createElement("img");
            im.src = u;
            im.loading = "lazy";
            im.alt = "Gada image " + (i + 1);
            if (i === 0) im.classList.add("on");
            box.insertBefore(im, $("carBadge"));
            var t = document.createElement("img");
            t.src = THUMBS[i];
            t.loading = "lazy";
            t.alt = "Thumb " + (i + 1);
            if (i === 0) t.classList.add("on");
            t.addEventListener("click", function () {
              goGal(i);
            });
            th.appendChild(t);
          });
          $("carCt").textContent = "1/" + GALLERY.length;
        }
        buildGallery("warrior7");
        buildGallery._last = "warrior7";
        $("carPrev").addEventListener("click", function () {
          goGal(galIdx - 1);
        });
        $("carNext").addEventListener("click", function () {
          goGal(galIdx + 1);
        });
        function goGal(i) {
          galIdx = (i + GALLERY.length) % GALLERY.length;
          var mains = $("carBox").querySelectorAll("img");
          var ths = $("thumbs").querySelectorAll("img");
          mains.forEach(function (im, k) {
            im.classList.toggle("on", k === galIdx);
          });
          ths.forEach(function (im, k) {
            im.classList.toggle("on", k === galIdx);
          });
          $("carCt").textContent = galIdx + 1 + "/" + GALLERY.length;
        }

        /* ---------- weight tiles ---------- */
        (function () {
          var g = $("wtGrid");
          WEIGHTS.forEach(function (w, i) {
            var d = document.createElement("div");
            d.className =
              "wt" +
              (w.series === "Indra" ? " indra" : "") +
              (i === selWt ? " on" : "");
            d.innerHTML =
              '<div class="rec" id="rec' +
              i +
              '">Recommended</div>' +
              '<div class="ser">' +
              w.series +
              (w.series === "Indra" ? " \u00B7 White" : "") +
              "</div>" +
              '<div class="kg">' +
              w.kg +
              " Kg</div>" +
              '<div class="pr">' +
              rupee(w.price) +
              (w.mrp ? " <s>" + rupee(w.mrp) + "</s>" : "") +
              "</div>";
            d.addEventListener("click", function () {
              setWeight(i);
            });
            g.appendChild(d);
          });
        })();
        function setWeight(i) {
          selWt = i;
          var w = WEIGHTS[i];
          document.querySelectorAll("#wtGrid .wt").forEach(function (el, k) {
            el.classList.toggle("on", k === i);
          });
          $("pdpKicker").textContent = "Tagda Raho \u00B7 Modular Series";
          $("pdpTitle").innerHTML =
            "The Warrior Club" +
            " \u2014 <span class='b'>" +
            w.kg +
            " Kg</span>";
          $("pdpSub").textContent =
            (w.series === "Indra"
              ? "Handcrafted premium Sheesham \u00B7 white finish \u00B7 Limited stock"
              : "Handcrafted Sheesham \u00B7 interchangeable grip system \u00B7 Dharwad bundle available") +
            " \u00B7 Free coached course included";
          $("priceMain").textContent = rupee(w.price);
          if (w.mrp) {
            $("priceMrp").style.display = "";
            $("priceMrp").textContent = rupee(w.mrp);
          } else {
            $("priceMrp").style.display = "none";
          }
          var url = URLS[w.kg];
          $("btnCart").href = url;
          $("btnBuy").href = url;
          $("barShopBtn").href = url;
          $("barBuyBtn").href = url;
          $("barName").textContent = "Warrior Club \u00B7 " + w.kg + " Kg";
          $("barPrice").textContent = rupee(w.price);
          $("carBadge").textContent = "Modular Series";
          $("barDisc").textContent = rupee(Math.round(w.price * 0.9));
          $("barOrig").textContent = rupee(w.price);
          var k = galKey();
          if (k !== buildGallery._last) {
            buildGallery(k);
            buildGallery._last = k;
          }
        }

        /* ---------- quiz ---------- */
        function renderQuiz() {
          var box = $("quizBox");
          if (!quiz.done) {
            var q = QUIZ[quiz.step];
            box.classList.remove("result");
            var dots = [0, 1, 2]
              .map(function (i) {
                return '<i class="' + (i <= quiz.step ? "on" : "") + '"></i>';
              })
              .join("");
            var opts = q.o
              .map(function (o) {
                return (
                  '<div class="qopt" data-pts="' + o[1] + '">' + o[0] + "</div>"
                );
              })
              .join("");
            box.innerHTML =
              '<div class="qhead"><span class="qstep">Question ' +
              (quiz.step + 1) +
              ' of 3</span><div class="qdots">' +
              dots +
              "</div></div>" +
              '<div class="qq">' +
              q.q +
              "</div>" +
              opts;
            box.querySelectorAll(".qopt").forEach(function (el) {
              el.addEventListener("click", function () {
                quizPick(parseInt(el.getAttribute("data-pts"), 10));
              });
            });
          } else {
            var w = WEIGHTS[quiz.rec];
            box.classList.add("result");
            box.innerHTML =
              '<div class="rlabel">Your match</div>' +
              '<div class="rname">' +
              "Warrior Club" +
              ' <span class="b">' +
              w.kg +
              " Kg</span></div>" +
              (w.series === "Classic"
                ? '<div class="rsub">Natural sheesham \u00B7 handcrafted \u00B7 ' +
                  rupee(w.price) +
                  "</div>"
                : "") +
              '<div class="rwhy">' +
              REC_REASON[quiz.rec] +
              "</div>" +
              '<button class="btn-red" data-scroll="pdp">See Your Gada \u2192</button>' +
              '<div class="retake">Retake</div>';
            box.querySelector(".retake").addEventListener("click", function () {
              quiz = { step: 0, score: 0, done: false, rec: -1 };
              for (var i = 0; i < WEIGHTS.length; i++) {
                var rc = $("rec" + i);
                if (rc) rc.classList.remove("show");
              }
              renderQuiz();
            });
            bindScrollBtns(box);
          }
        }
        function quizPick(pts) {
          quiz.score += pts;
          if (quiz.step >= QUIZ.length - 1) {
            quiz.done = true;
            quiz.rec = quiz.score <= 3 ? 0 : 1;
            setWeight(quiz.rec);
            for (var i = 0; i < WEIGHTS.length; i++) {
              var rc = $("rec" + i);
              if (rc) rc.classList.toggle("show", i === quiz.rec);
            }
          } else {
            quiz.step++;
          }
          renderQuiz();
        }
        renderQuiz();

        /* ---------- muscles list ---------- */
        (function () {
          var list = $("mList");
          MUSCLES.forEach(function (m, i) {
            var row = document.createElement("div");
            row.className = "mrow";
            row.setAttribute("data-i", i);
            var segs = [0, 1, 2, 3, 4]
              .map(function (s) {
                var fill = Math.min(1, Math.max(0, m.score - s)) * 100;
                return '<div class="seg"><i data-w="' + fill + '"></i></div>';
              })
              .join("");
            var scoreTxt = m.score % 1 === 0 ? m.score : m.score.toFixed(1);
            row.innerHTML =
              '<div class="top"><span class="nm">' +
              m.name +
              '</span><span class="sc">' +
              scoreTxt +
              "<small> / 5</small></span></div>" +
              '<div class="segs">' +
              segs +
              '</div><div class="ds">' +
              m.desc +
              "</div>";
            list.appendChild(row);
          });
          var st = document.createElement("div");
          st.id = "mStatement";
          st.innerHTML =
            'From grip to core, every swing demands <span class="b">full-body engagement</span>';
          list.appendChild(st);
        })();

        /* ---------- countups ---------- */
        function animateCount(el) {
          var end = parseFloat(el.getAttribute("data-end"));
          var dec = parseInt(el.getAttribute("data-dec") || "0", 10);
          var pre = el.getAttribute("data-prefix") || "";
          var suf = el.getAttribute("data-suffix") || "";
          if (REDUCED) {
            el.textContent =
              pre +
              (dec ? end.toFixed(dec) : end.toLocaleString("en-IN")) +
              suf;
            return;
          }
          var t0 = performance.now(),
            dur = 1400;
          function tick(t) {
            var p = Math.min(1, (t - t0) / dur),
              e = 1 - Math.pow(1 - p, 3),
              v = end * e;
            el.textContent =
              pre +
              (dec ? v.toFixed(dec) : Math.round(v).toLocaleString("en-IN")) +
              suf;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        }

        /* ---------- live load (dock readout) ---------- */
        (function () {
          var el = $("liveLoad");
          if (REDUCED) {
            el.textContent = "18\u201322 kg";
            return;
          }
          var t0 = performance.now();
          function tick(t) {
            var s = Math.abs(Math.sin((t - t0) / 1200));
            el.textContent = (7 * (1.9 + 1.7 * s)).toFixed(1) + " kg";
            requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        })();

        /* ---------- scroll buttons ---------- */
        function bindScrollBtns(root) {
          (root || document)
            .querySelectorAll("[data-scroll]")
            .forEach(function (b) {
              if (b._bound) return;
              b._bound = true;
              b.addEventListener("click", function () {
                var t = document.getElementById(b.getAttribute("data-scroll"));
                if (t)
                  window.scrollTo({
                    top: t.getBoundingClientRect().top + window.scrollY - 60,
                    behavior: "smooth",
                  });
              });
            });
        }
        bindScrollBtns();

        /* ---------- master scroll handler ---------- */
        var heroFx = $("heroFx"),
          heroGlow = $("heroGlow"),
          clubBox = $("clubBox"),
          gadaWrap = $("gadaWrap"),
          gadaRock = $("gadaRock"),
          heroTitle = $("heroTitle"),
          trLogoTop = $("trLogoTop"),
          dockbox = $("dockbox"),
          swingOuter = $("swingOuter"),
          swingSticky = $("swingSticky"),
          stage = $("stage"),
          ctabar = $("ctabar");

        function onScroll() {
          var vh = window.innerHeight,
            vw = window.innerWidth,
            sy = window.scrollY;
          var range = vh * 2.8,
            raw = Math.min(1, Math.max(0, sy / range));
          var tP = Math.min(1, raw / 0.16);
          var pre = Math.min(1, raw / 0.2);
          function segp(a, b) {
            return raw <= a ? 0 : raw >= b ? 1 : (raw - a) / (b - a);
          }
          var wcF;
          if (raw < 0.04) wcF = 0;
          else if (raw < 0.17) wcF = Math.round(segp(0.04, 0.17) * 11);
          else if (raw < 0.22) wcF = 11; /* Warrior (initial) — no callout */
          else if (raw < 0.36) wcF = 12 + Math.round(segp(0.22, 0.36) * 13);
          else if (raw < 0.45) wcF = 25; /* Default seated */
          else if (raw < 0.58) wcF = 26 + Math.round(segp(0.45, 0.58) * 11);
          else if (raw < 0.67) wcF = 37; /* Dharwad seated */
          else if (raw < 0.81) wcF = 38 + Math.round(segp(0.67, 0.81) * 17);
          else wcF = 55; /* Warrior returns */
          var rP = raw < 0.9 ? 0 : Math.min(1, (raw - 0.9) / 0.1);
          var locked = rP >= 1;
          var capIdx = -1;
          if (wcF === 25) capIdx = 0;
          else if (wcF === 37) capIdx = 1;
          else if (wcF === 55 && rP === 0) capIdx = 2;
          var capOp = capIdx >= 0 ? 1 : 0;

          heroFx.style.height =
            rP < 1
              ? "calc(" + (100 - rP * 100) + "vh + " + rP * 100 + "px)"
              : "100px";
          heroFx.style.overflow = rP < 1 ? "hidden" : "visible";
          heroFx.style.background =
            rP > 0.5
              ? "linear-gradient(180deg, #1E0F0D 0%, rgba(30,15,13," +
                Math.min(1, (rP - 0.5) * 2) * 0.93 +
                ") 80%, transparent 100%)"
              : "transparent";
          heroGlow.style.opacity = 1 - rP;
          trLogoTop.style.opacity = rP < 0.5 ? 0.08 * (1 - rP * 2) : 0;

          var DESK = vw >= 900 ? 0.68 : 1; /* desktop/laptop shrink factor, lower = smaller */
var heroImgH = Math.min(vh * 0.8, 540) * DESK,
    lockedImgH = Math.min(vw - 48, 360) * (vw >= 900 ? 0.85 : 1),
    vS = 1.25 - pre * 0.07 - rP * 0.18;
          var imgH = heroImgH * vS * (1 - rP) + lockedImgH * rP;
          var CB = imgH * 0.648;
          var wcW = CB * 1.7697;
          var wcMax = vw * 0.94;
          if (wcW > wcMax) {
            wcW = wcMax;
            CB = wcW / 1.7697;
          }
          clubBox.style.height = CB + "px";
          clubBox.style.width = wcW + "px";
          var zt = Math.min(1, raw / 0.05);
          var zf = 1 + (vw >= 900 ? 0.1 : 0.34) * (1 - zt) * (1 - zt);
          clubBox.style.transform = "scale(" + zf.toFixed(3) + ")";
          clubBox.style.backgroundPosition =
            ((wcF % 7) / 6) * 100 +
            "% " +
            (Math.floor(wcF / 7) / 7) * 100 +
            "%";
          clubBox.style.filter =
            "drop-shadow(0 " +
            Math.round(12 - rP * 10) +
            "px " +
            Math.round(28 - rP * 22) +
            "px rgba(0,0,0," +
            (0.6 - rP * 0.1) +
            "))";
          var CAPS = [
            ["01", "Tagda Default Grip"],
            ["02", "Dharwad Grip"],
            ["03", "Warrior Grip"],
          ];
          var gc = document.getElementById("gripCap");
          if (capIdx >= 0) {
            document.getElementById("gripIdx").textContent = CAPS[capIdx][0];
            document.getElementById("gripName").textContent = CAPS[capIdx][1];
          }
          gc.style.opacity = capOp;

          heroTitle.style.display = raw < 0.22 ? "" : "none";
          heroTitle.style.opacity = Math.max(0, 1 - tP * 1.6);
          heroTitle.style.transform =
            "translate(-50%,-50%) translateY(" + tP * -90 + "px)";

          /* fly to dock */
          var flyT = 0;
          var b = dockbox.getBoundingClientRect();
          var dy = 0,
            sc = 1;
          if (flyT > 0) {
            dy = (b.top + b.height / 2 - 50) * flyT;
            var targetW = Math.min(b.width * 0.66, 290);
            sc = 1 + (targetW / Math.max(120, lockedImgH * 0.648) - 1) * flyT;
          }
          gadaWrap.style.transform =
            "translateY(" +
            (dy + (vw >= 900 ? vh * 0.06 : -vh * 0.05) * (1 - rP)) +
            "px) scale(" +
            sc +
            ")";
          gadaRock.classList.toggle("rocking", flyT > 0.9 && !REDUCED);

          /* annotations */
          var f = "none";
          document.querySelectorAll("[data-annot]").forEach(function (s) {
            var r = s.getBoundingClientRect();
            if (r.top < vh * 0.4 && r.bottom > 120)
              f = s.getAttribute("data-annot");
          });
          ["annotL", "annotR"].forEach(function (id) {
            var box = $(id);
            box.style.display = locked && f !== "none" ? "flex" : "none";
            box.style.opacity = (id === "annotL" ? 0.8 : 0.45) * (1 - flyT);
            box.querySelectorAll(".an").forEach(function (a) {
              a.style.display =
                a.getAttribute("data-a") === f ? "flex" : "none";
              a.style.flexDirection = "column";
              a.style.alignItems = "center";
              a.style.gap = "4px";
            });
          });

          /* swing scrub */
          var so = swingOuter.getBoundingClientRect();
          var innerH = Math.min(vh - 150, 620);
          swingSticky.style.height = innerH + "px";
          var stageH = Math.min(vh * 0.33, 280);
          $("stageBox").style.height = stageH + "px";
          var run = so.height - innerH;
          var p = run > 0 ? Math.min(1, Math.max(0, (104 - so.top) / run)) : 0;
          var frame = Math.min(SPR.n - 1, Math.floor(p * SPR.n));
          stage.style.backgroundPosition =
            ((frame % SPR.cols) / (SPR.cols - 1)) * 100 +
            "% " +
            (Math.floor(frame / SPR.cols) / (SPR.rows - 1)) * 100 +
            "%";
          $("frameCt").textContent =
            String(frame + 1).padStart(2, "0") + "/" + SPR.n;
          /* directional swing arc */
          (function () {
            var cx = 120,
              cyA = 126,
              RX = 104,
              RY = 80;
            var th0 = -Math.PI / 2,
              sweep = Math.min(p, 0.995) * 2 * Math.PI,
              th = th0 + sweep;
            var trail = $("arcTrail"),
              head = $("arcHead");
            if (p > 0.01) {
              var sx = cx + RX * Math.cos(th0),
                syA = cyA + RY * Math.sin(th0);
              var ex = cx + RX * Math.cos(th),
                ey = cyA + RY * Math.sin(th);
              var la = sweep > Math.PI ? 1 : 0;
              trail.setAttribute(
                "d",
                "M " +
                  sx +
                  " " +
                  syA +
                  " A " +
                  RX +
                  " " +
                  RY +
                  " 0 " +
                  la +
                  " 1 " +
                  ex +
                  " " +
                  ey,
              );
              head.style.display = "";
              head.setAttribute(
                "transform",
                "translate(" +
                  ex +
                  "," +
                  ey +
                  ") rotate(" +
                  ((th + Math.PI / 2) * 180) / Math.PI +
                  ")",
              );
            } else {
              trail.setAttribute("d", "");
              head.style.display = "none";
            }
          })();
          $("swingProg").style.width = p * 100 + "%";
          var kg = 7;
          $("loadTxt").textContent =
            (kg * (1 + 2.6 * Math.pow(Math.sin(Math.PI * p), 2))).toFixed(1) +
            " kg";
          $("momBar").style.width = Math.sin(Math.PI * p) * 100 + "%";
          var ph = p < 0.18 ? 0 : p < 0.5 ? 1 : p < 0.78 ? 2 : 3;
          $("phaseTxt").textContent = PHASES[ph][0];
          $("phName").textContent = PHASES[ph][0];
          $("phDesc").textContent = PHASES[ph][1];
          $("ticks")
            .querySelectorAll("i")
            .forEach(function (t, i) {
              t.classList.toggle("on", i <= ph);
            });

          /* countups */
          document.querySelectorAll(".cu").forEach(function (el) {
            if (el._done) return;
            var r = el.getBoundingClientRect();
            if (r.top < vh - 60 && r.bottom > 0) {
              el._done = true;
              animateCount(el);
            }
          });

          /* muscles */
          var rows = document.querySelectorAll(".mrow"),
            am = -1,
            best = 1e9;
          rows.forEach(function (row, i) {
            var r = row.getBoundingClientRect();
            if (r.top < vh * 0.75) row.classList.add("fill");
            var d = Math.abs((r.top + r.bottom) / 2 - vh * 0.5);
            if (r.top < vh && r.bottom > 0 && d < best) {
              best = d;
              am = i;
            }
          });
          rows.forEach(function (row, i) {
            var on = i === am;
            row.classList.toggle("on", on);
            row.querySelectorAll(".seg i").forEach(function (seg) {
              seg.style.width = row.classList.contains("fill")
                ? seg.getAttribute("data-w") + "%"
                : "0%";
            });
            var rg = $("rg" + i);
            if (rg) rg.classList.toggle("on", on);
          });
          var names = ["shoulders", "core", "forearms", "lats", "hips"];
          $("rgName").textContent = am >= 0 ? names[am] : "";
          $("rgName").classList.toggle("show", am >= 0);

          /* doubts transition */
          (function () {
            var dz = $("doubts");
            if (!dz) return;
            var r = dz.getBoundingClientRect();
            var t = Math.min(
              1,
              Math.max(0, (vh - r.top) / (r.height + vh * 0.35)),
            );
            dz.querySelectorAll(".db").forEach(function (el) {
              var dl = parseFloat(el.getAttribute("data-dl"));
              var local = Math.min(1, Math.max(0, (t - dl) / 0.65));
              var op = Math.pow(Math.sin(Math.PI * local), 1.2) * 0.92;
              var x =
                parseFloat(el.getAttribute("data-x")) * (1 - local * 0.85);
              var y =
                parseFloat(el.getAttribute("data-y")) * (1 - local * 0.85);
              var rr = parseFloat(el.getAttribute("data-r")) * (1 - local);
              el.style.opacity = op;
              el.style.transform =
                "translate(-50%,-50%) translate(" +
                x +
                "px," +
                y +
                "px) rotate(" +
                rr +
                "deg)";
            });
            $("doubtDot").style.opacity = Math.min(0.7, t);
          })();

          /* sticky bar */
          ctabar.classList.toggle("show", locked);
         var pdpTop = $("pdp").getBoundingClientRect().top;
        var revEl = $("reviews") || $("quote") || $("finalCta");
        var revTop = revEl ? revEl.getBoundingClientRect().top : Infinity;
          var mode =
            revTop < vh * 0.7
              ? "barClose"
              : pdpTop < vh
                ? "barShop"
                : "barLearn";
          ["barLearn", "barShop", "barClose"].forEach(function (id) {
            $(id).classList.toggle("on", id === mode);
          });
        }
        document.querySelectorAll(".db").forEach(function (el) {
          el.addEventListener("click", function () {
            var t = document.getElementById("coach");
            if (t)
              window.scrollTo({
                top: t.getBoundingClientRect().top + window.scrollY - 40,
                behavior: "smooth",
              });
          });
        });
        document
          .getElementById("heroTitle")
          .addEventListener("click", function () {
            window.scrollTo({
              top: window.innerHeight * 3.2,
              behavior: "smooth",
            });
          });
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        onScroll();
      })();
    /* ---------- BUY / CART buttons (self-contained) ---------- */
(function () {
  var AFTER_ADD = '/cart';

  function selectedKg() {
    var el = document.querySelector('#pdpTitle .b');
    var m = el && el.textContent.match(/\d+/);
    return m ? parseInt(m[0], 10) : 7;
  }

  function pickVariant() {
    var all = window.WARRIOR_PRODUCTS || {};
    var prod = all[selectedKg()];
    if (!prod || !prod.variants) return null;
    var wantDharwad = window.selGrip === 'dharwad';
    var ok = prod.variants.filter(function (v) { return v.available; });
    var match = ok.filter(function (v) {
      return /dharwad/i.test(v.title) === wantDharwad;
    })[0];
    return match || ok[0] || null;
  }

  function openMiniCart() {
    ['cart:refresh', 'cart:open', 'cart:updated', 'cart:change', 'cart-drawer:refresh'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { open: true } }));
    });
    setTimeout(function () {
      var d = document.querySelector('cart-drawer, wt-cart, .wt-cart');
      if (d && typeof d.open === 'function') { d.open(); return; }
      var icon = document.querySelector('[data-gokwik-cart], .gokwik-cart-icon, #cart-icon-bubble, [data-cart-toggle], [data-cart-drawer-toggle], .js-drawer-open-cart, .header__icon--cart, a[href="/cart"]');
      if (icon) { icon.click(); return; }
      window.location.href = AFTER_ADD;
    }, 150);
  }

  function addToCart(variant) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().then(function (e) {
        throw new Error(e.description || e.message || 'Could not add to cart');
      });
    });
  }

  function goKwikBuyNow(ev, variant) {
    var tries = 0;
    (function go() {
      if (typeof window.onBuyNowClick === 'function') {
        window.onBuyNowClick(ev, false, [{ id: variant.id, quantity: 1 }]);
        return;
      }
      if (++tries < 15) { setTimeout(go, 200); return; }
      /* Fallback: cart permalink -> direct checkout. Remove ?discount=FITINDIA if not wanted. */
      window.location.href = '/cart/' + variant.id + ':1?discount=FITINDIA';
    })();
  }

  function wire(id, buyNow) {
    var btn = document.getElementById(id);
    if (!btn) { console.warn('wire: #' + id + ' not found'); return; }
    var label = btn.textContent;
    function reset() { btn.textContent = label; btn.removeAttribute('aria-busy'); }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.getAttribute('aria-busy')) return;
      var v = pickVariant();
      if (!v) { alert('Sorry, this Gada is currently sold out.'); return; }
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = buyNow ? 'PLEASE WAIT\u2026' : 'ADDING\u2026';

      if (buyNow) {
        goKwikBuyNow(e, v);
        setTimeout(reset, 3000);
        return;
      }
      addToCart(v)
        .then(function () { openMiniCart(); reset(); })
        .catch(function (err) { alert(err.message); reset(); });
    });

    window.addEventListener('pageshow', function (ev) { if (ev.persisted) reset(); });
  }

  function init() {
    wire('btnCart', false);
    wire('btnBuy', true);
    wire('barBuyBtn', true);
    wire('barShopBtn', true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();